/* =========================================================================
   reinperle — enhance.js
   Additive Animations-Schicht. Greift NICHT in bestehende Logik ein.
   - Scroll-Reveals via IntersectionObserver
   - Klick-/Tap-Pop-Feedback
   - Warenkorb-Badge-Bump bei Mengenänderung
   - Weiches Einblenden von Bildern
   Respektiert prefers-reduced-motion vollständig.
   ========================================================================= */

/* i18n: Strings aus den Shopify-Sprachdateien (siehe theme.liquid) */
var enhT = (typeof window !== 'undefined' && window.mfyT) ? window.mfyT : function (k, fb) { return fb; };
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1 · Reveal-Ziele automatisch markieren (ohne Markup zu ändern)
     --------------------------------------------------------------------- */
  function tagReveals() {
    // Sektions-Überschriften
    document.querySelectorAll('.section-head').forEach(function (el) {
      el.classList.add('reveal');
    });

    // Container, deren Kinder gestaffelt aufploppen sollen
    // Container, deren Kinder gestaffelt aufploppen sollen.
    // Bewusst OHNE die horizontal scrollenden Rails (.rail, .community__rail),
    // damit deren Touch-Scrolling absolut flüssig bleibt.
    var staggerSelectors = [
      '.benefits__grid',
      '.reviews__grid',
      '.notes__grid',
      '.how__steps',
      '.bundle__grid',
      '.usp',
      '.assure'
    ];
    staggerSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('reveal', 'reveal-stagger');
      });
    });

    // Einzelne größere Blöcke, die als Ganzes einschweben
    var blockSelectors = [
      '.bundle__card',
      '.newsletter__card',
      '.trust',
      '.faq',
      '.how',
      '.notes',
      '.reviews',
      '.community',
      '.benefits'
    ];
    blockSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // nicht doppelt taggen, wenn schon ein Stagger-Container
        if (!el.classList.contains('reveal-stagger')) {
          el.classList.add('reveal');
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
     2 · IntersectionObserver schaltet .is-in
     --------------------------------------------------------------------- */
  function observeReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
     3 · Tap-Pop-Feedback auf Buttons & klickbaren Elementen
     --------------------------------------------------------------------- */
  function wireTapPop() {
    if (reduce) return;
    var sel = '.btn, .add, .sw, .gthumb, .upsell__btn, .qtybox button, .ci__qty button';
    document.addEventListener('click', function (e) {
      var t = e.target.closest(sel);
      if (!t) return;
      t.classList.remove('tap-pop');
      // reflow, damit die Animation erneut startet
      void t.offsetWidth;
      t.classList.add('tap-pop');
      setTimeout(function () { t.classList.remove('tap-pop'); }, 450);
    }, { passive: true });
  }

  /* ---------------------------------------------------------------------
     4 · Warenkorb-Badge hüpft, wenn sich der Zähler ändert
     --------------------------------------------------------------------- */
  function watchCartCount() {
    if (reduce) return;
    var badge = document.getElementById('cart-count');
    if (!badge || !('MutationObserver' in window)) return;

    var last = badge.textContent;
    var mo = new MutationObserver(function () {
      if (badge.textContent !== last) {
        last = badge.textContent;
        badge.classList.remove('bump');
        void badge.offsetWidth;
        badge.classList.add('bump');
      }
    });
    mo.observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* ---------------------------------------------------------------------
     5 · Bilder weich einblenden, sobald geladen
     --------------------------------------------------------------------- */
  function fadeInImages() {
    if (reduce) return;
    document.querySelectorAll('img').forEach(function (img) {
      if (img.closest('.mfy-poster-pdp')) return;
      // Hero-Hintergrund & schon geladene überspringen
      if (img.complete && img.naturalWidth > 0) return;
      img.style.opacity = '0';
      var show = function () { img.style.opacity = '1'; };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
    });
  }

  /* ---------------------------------------------------------------------
     Init — auch bei Shopify-Theme-Editor-Neuladevorgängen robust
     --------------------------------------------------------------------- */
  function init() {
    tagReveals();
    observeReveals();
    wireTapPop();
    watchCartCount();
    fadeInImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Section-Rendering (Theme-Editor): neue Inhalte erneut taggen
  document.addEventListener('shopify:section:load', function () {
    tagReveals();
    observeReveals();
  });
})();

/* =========================================================================
   magazinforyou — Varianten-Auswahl (additive Schicht)
   Verbindet die echten Produktvarianten mit der reinperle-Kaufbox.
   - Liest die Varianten aus #product-variants-data (JSON von Shopify)
   - Aktualisiert beim Auswählen: #buy-add (data-variant), Preis, Sticky-Bar
   - Nutzt dieselben data-Attribute, die script.js bereits liest
   ========================================================================= */
(function () {
  'use strict';

  function formatEuro(cents) {
    try {
      return (cents / 100).toLocaleString('de-DE', {
        style: 'currency', currency: 'EUR'
      });
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initVariantPicker() {
    var dataEl = document.getElementById('product-variants-data');
    var buyAdd = document.getElementById('buy-add');
    if (!dataEl || !buyAdd) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); }
    catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var optionGroups = Array.prototype.slice.call(
      document.querySelectorAll('.vswatches')
    );
    if (!optionGroups.length) return;

    // aktuell gewählte Optionswerte je Option-Index
    var selected = [];
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var active = group.querySelector('.vswatch.is-active');
      if (active) selected[idx] = active.dataset.optionValue;
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        for (var i = 0; i < optionGroups.length; i++) {
          var idx = parseInt(optionGroups[i].dataset.optionIndex, 10);
          if (selected[idx] == null) return false;
          if (opts[idx] !== selected[idx]) return false;
        }
        return true;
      });
    }

    function setText(sel, text) {
      var el = document.querySelector(sel);
      if (el && text != null) el.textContent = text;
    }

    function applyVariant(v) {
      if (!v) return;
      // Kauf-Button aktualisieren
      buyAdd.dataset.variant = v.id;
      var productFormVariant = document.getElementById('product-form-variant-id');
      if (productFormVariant) productFormVariant.value = v.id;
      // Preis (Kaufbox)
      var saleEl = document.getElementById('buy-sale');
      if (saleEl) saleEl.textContent = formatEuro(v.price);
      // Sticky-Leiste
      setText('#sticky-price', formatEuro(v.price));
      // Vergleichspreis / Rabatt-Badge
      var compareEl = document.querySelector('.buy__compare');
      var offEl = document.querySelector('.buy__off');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (compareEl) compareEl.textContent = formatEuro(v.compare_at_price);
        if (offEl) {
          var pct = Math.round(
            (v.compare_at_price - v.price) * 100 / v.compare_at_price
          );
          offEl.textContent = '-' + pct + ' %';
        }
      } else {
        if (compareEl) compareEl.textContent = '';
        if (offEl) offEl.textContent = '';
      }
      // Button-Zustand bei Nichtverfügbarkeit
      if (v.available === false) {
        buyAdd.setAttribute('disabled', 'disabled');
        buyAdd.textContent = enhT('sold_out', 'ausverkauft');
      } else {
        buyAdd.removeAttribute('disabled');
        buyAdd.textContent = enhT('add_to_cart', 'in den warenkorb legen');
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.vswatch');
        if (!btn) return;
        var idx = parseInt(group.dataset.optionIndex, 10);
        selected[idx] = btn.dataset.optionValue;
        group.querySelectorAll('.vswatch').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        applyVariant(findVariant());
      });
    });

    // Initialzustand anwenden
    applyVariant(findVariant());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPicker);
  } else {
    initVariantPicker();
  }
  document.addEventListener('shopify:section:load', initVariantPicker);
})();

/* =========================================================================
   magazinforyou — eigenständige PDP-Bundle-Section
   - Bundle-Liquid bleibt separat in sections/pdp-bundle.liquid
   - Section wird mobilfreundlich in den Slot über dem bestehenden Warenkorb-Button verschoben
   - Der bestehende Warenkorb-Button fügt je nach Auswahl Einzelprodukt oder Bundle hinzu
   ========================================================================= */
(function () {
  'use strict';

  function uniqueIds(raw) {
    return (raw || '')
      .split(',')
      .map(function (value) { return value.trim(); })
      .filter(Boolean)
      .filter(function (value, index, arr) { return arr.indexOf(value) === index; });
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function moveBundleIntoSlot(root) {
    var slot = document.getElementById('pdp-bundle-slot');
    if (!root || !slot) return;
    var carrier = root.closest('.shopify-section') || root;
    if (slot.contains(carrier)) return;
    slot.appendChild(carrier);
  }

  function setSelected(root, options, value) {
    root.dataset.selected = value || 'single';
    options.forEach(function (option) {
      var active = option.dataset.option === root.dataset.selected;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  }


  function formatCountdown(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    function pad(value) { return String(value).padStart(2, '0'); }
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function msUntilLocalMidnight() {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return midnight.getTime() - now.getTime();
  }

  function initBundleCountdown(root) {
    if (!root) return;
    var badge = root.querySelector('[data-pbx-countdown]');
    if (!badge || badge.dataset.countdownReady === '1') return;
    badge.dataset.countdownReady = '1';

    var prefix = badge.dataset.countdownPrefix || 'Endet in';
    function update() {
      badge.textContent = prefix + ' ' + formatCountdown(msUntilLocalMidnight());
    }

    update();
    window.setInterval(update, 1000);
  }

  function selectedIds(root) {
    var raw = root.dataset.selected === 'bundle' ? root.dataset.bundleVids : root.dataset.singleVids;
    var ids = uniqueIds(raw);
    var mainAdd = document.getElementById('buy-add');
    var currentVariant = mainAdd && mainAdd.dataset && mainAdd.dataset.variant;
    if (ids.length && currentVariant) ids[0] = currentVariant;
    return uniqueIds(ids.join(','));
  }

  function productFormLineProperties() {
    var form = document.getElementById('product-upload-form');
    var props = {};
    try {
      if (!form || typeof FormData === 'undefined') throw new Error('Produktformular nicht verfügbar');
      var data = new FormData(form);
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(String(key || ''));
        if (!match) return;
        var propName = match[1];
        if (!propName) return;
        if (typeof File !== 'undefined' && value instanceof File) {
          if (value.name) props[propName] = value.name;
          return;
        }
        var stringValue = String(value == null ? '' : value).trim();
        if (stringValue) props[propName] = stringValue;
      });
    } catch (err) {
      console.warn('uploadly properties konnten nicht gelesen werden', err);
    }
    var currentPreview = currentMfyAiPreview();
    if (currentPreview) props._MFY_AI_PREVIEW = currentPreview;
    return props;
  }

  function currentMfyAiPreview() {
    var hidden = document.querySelector("#mfy-ai-preview-property, input[name='properties[_MFY_AI_PREVIEW]']");
    var teeinblueImage = document.querySelector("#tee-customization-image, input[name='properties[_customization_image]']");
    var liveImage = document.querySelector('[data-mfy-ai-poster-preview] > img');
    var candidates = [
      hidden && hidden.value,
      liveImage && (liveImage.currentSrc || liveImage.src),
      teeinblueImage && teeinblueImage.value
    ];

    try {
      var key = 'mfy-ai-artwork-v1:' + window.location.pathname.replace(/\/$/, '');
      candidates.push(window.sessionStorage.getItem(key));
    } catch (err) {}

    for (var index = 0; index < candidates.length; index += 1) {
      if (!candidates[index]) continue;
      try {
        var url = new URL(String(candidates[index]).trim(), document.baseURI).href;
        if (/^https?:/i.test(url)) return url;
      } catch (err) {}
    }
    return '';
  }


  function setMainLoading(btn, state) {
    if (!btn) return;
    if (state) {
      btn.dataset.originalText = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = enhT('adding', 'wird hinzugefügt …');
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.innerHTML = btn.dataset.originalText || enhT('add_to_cart', 'in den warenkorb legen');
    }
  }

  function addSelectedBundle(root, button) {
    var ids = selectedIds(root);
    var sellingPlan = button && button.dataset ? button.dataset.sellingPlan : '';
    var isBundle = root.dataset.selected === 'bundle';
    var paidIds = uniqueIds(root.dataset.bundlePaidVids || '');
    var freeIds = uniqueIds(root.dataset.bundleFreeVids || '');
    var currentVariant = button && button.dataset ? button.dataset.variant : '';
    if (isBundle && paidIds.length && currentVariant) paidIds[0] = String(currentVariant);
    var bundleId = isBundle ? ('mf_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8)) : '';
    var requiredPaid = isBundle ? uniqueIds(paidIds.join(',')).join(',') : '';
    var title = root.dataset.bundleTitle || 'Magazinforyou Bundle';
    var uploadProps = productFormLineProperties();

    var items = ids.map(function (id, index) {
      var idString = String(id);
      var item = { id: Number(id), quantity: 1 };
      if (index === 0 && sellingPlan) item.selling_plan = Number(sellingPlan);
      if (isBundle && bundleId) {
        item.properties = {
          '_mf_bundle_id': bundleId,
          '_mf_bundle_title': title,
          '_mf_bundle_role': freeIds.indexOf(idString) !== -1 ? 'free' : 'paid',
          '_mf_bundle_required_paid': requiredPaid
        };
      }
      if (index === 0 && uploadProps && Object.keys(uploadProps).length) {
        item.properties = Object.assign({}, item.properties || {}, uploadProps);
      }
      return item;
    }).filter(function (item) {
      return item.id && !isNaN(item.id);
    });

    if (!items.length) return Promise.resolve();

    setMainLoading(button, true);
    if (typeof window.openCart === 'function') window.openCart();

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return response.json();
      })
      .then(function () {
        if (typeof window.syncCartFromShopify === 'function') return window.syncCartFromShopify();
      })
      .then(function () {
        if (typeof window.showToast === 'function') {
          window.showToast(root.dataset.selected === 'bundle' ? enhT('bundle_added', 'bundle added to cart ♥') : enhT('product_added', 'product added to cart ♥'));
        }
      })
      .catch(function (error) {
        console.error('pdp bundle add error:', error);
        if (typeof window.showToast === 'function') window.showToast(enhT('cart_update_error', 'cart could not be updated'));
      })
      .finally(function () {
        setMainLoading(button, false);
      });
  }

  function initPdpBundle() {
    var root = document.getElementById('pdp-bundle');
    if (!root) return;

    moveBundleIntoSlot(root);
    initBundleCountdown(root);

    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    if (!options.length) return;

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        setSelected(root, options, option.dataset.option || 'single');
      });
    });

    setSelected(root, options, root.dataset.selected || 'bundle');

    var mainAdd = document.getElementById('buy-add');
    if (mainAdd && mainAdd.dataset.pbxReady !== '1') {
      mainAdd.dataset.pbxReady = '1';
      mainAdd.addEventListener('click', function (event) {
        var activeRoot = document.getElementById('pdp-bundle');
        if (!activeRoot || mainAdd.disabled) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        addSelectedBundle(activeRoot, mainAdd);
      }, true);
    }

    var stickyAdd = document.getElementById('sticky-add');
    if (stickyAdd && stickyAdd.dataset.pbxReady !== '1') {
      stickyAdd.dataset.pbxReady = '1';
      stickyAdd.addEventListener('click', function (event) {
        var activeRoot = document.getElementById('pdp-bundle');
        var mainAddBtn = document.getElementById('buy-add');
        if (!activeRoot || !mainAddBtn) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        addSelectedBundle(activeRoot, mainAddBtn);
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpBundle);
  } else {
    initPdpBundle();
  }

  document.addEventListener('shopify:section:load', function () {
    var root = document.getElementById('pdp-bundle');
    if (root) root.dataset.ready = '';
    initPdpBundle();
  });
})();
